import { ICorporateActionsApiRes } from "../types/corporate-actions-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getCorporateActions = async (exchId: string, token: string) => {
  const response: ICorporateActionsApiRes = await request({
    method: "POST",
    url: API_PATHS.corporateActions,
    data: {
      exchId: +exchId,
      token: +token,
      _csrf: "gUFgghHB-wO1KkJitKjaPkIQab9HA9facGsc",
    },
  });
  return response;
};
